import React from "react";

import { Box, Typography } from "@material-ui/core";
import { SectionContainer } from "@product-site-frontend/shared";

import ConsultationForm from "../../components/ConsultationForm";
import ConsultationFormForSber from "../../components/ConsultationFormForSber";

export default function SectionConsultation() {

  const renderTypeForm = () => {
    if (process.env.GATSBY_PARTNER_SLUG === "you_win") {
      return (
        <div>
          <script src="https://forms.yandex.ru/_static/embed.js"></script>
          <iframe
            src="https://forms.yandex.ru/cloud/6a4cfa8602848f0ad48a3514?iframe=1"
            frameBorder="0"
            name="ya-form-6a4cfa8602848f0ad48a3514"
            width="650"
          ></iframe>
        </div>
      );
    } else if (typeof window !== "undefined" && window.location.pathname.includes("sber")) {
      return <ConsultationFormForSber />;
    } else {
      return <ConsultationForm />;
    }
  }

  return (
    <Box
      id={"section_consultation"}
      sx={{ mt: 8, backgroundColor: "#f8f8f9", scrollMarginTop: "144px" }}
    >
      <SectionContainer>
        <Box display="flex" flexWrap="wrap">
          <Box mr={{ lg: 8 }} width={{ xs: 1, lg: 0.5 }}>
            <Typography component="div" textAlign="left !important" variant="h2">
              {process.env.GATSBY_PARTNER_SLUG === "you_win" ? (
                <span style={{ fontSize: "26px" }}>
                  Запланируйте чекап вашей бизнес-идеи с основателем Аренза 360!
                </span>
              ) : (
                <>Хотите воспользоваться лизингом, но&nbsp;не&nbsp;знаете, с&nbsp;чего начать?</>
              )}
            </Typography>
            <Typography color="#373737" fontWeight={500} mb={5} mt={3} variant="body1">
              {process.env.GATSBY_PARTNER_SLUG !== "you_win" && (
                <>Наша команда с&nbsp;радостью ответит на&nbsp;ваши вопросы!</>
              )}
              <br />
              Заполните форму, и&nbsp;мы свяжемся с вами в&nbsp;ближайшее время.
            </Typography>
          </Box>
          <Box width={{ xs: 1, lg: 0.35 }}>{renderTypeForm()}</Box>
        </Box>
      </SectionContainer>
    </Box>
  );
}
